import { render, staticRenderFns } from "./EditorBtn.vue?vue&type=template&id=86a4311e&scoped=true&"
import script from "./EditorBtn.vue?vue&type=script&lang=js&"
export * from "./EditorBtn.vue?vue&type=script&lang=js&"
import style0 from "./EditorBtn.vue?vue&type=style&index=0&id=86a4311e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a4311e",
  null
  
)

export default component.exports